import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Row } from "reactstrap";
import { Grid, _ } from 'gridjs-react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { useHistory } from 'react-router-dom';
import { deleteGrapeType, getAllGrapeTypes } from '../../helpers/api/product/product';
import { deleteGrapeOfTheWeek, getGrapesOfTheWeeks } from '../../helpers/api/information/information';

const GrapeOfTheWeekTable = () => {
    const [grapes, setgrapes] = useState([]);

    const history = useHistory();

    document.title = "My Grapes Of The Weeks";

    const getGrapes = async () => {
        try {
            setgrapes([]);
            let response = await getGrapesOfTheWeeks();
            if (!response.success) throw response.data;

            setgrapes(response.data.map(row => {
                return [
                    row.id,
                    row.StartDate.split("T")[0],
                    row.EndDate.split("T")[0],
                    row.GrapeName,
                    row.GrapePicture
                ]
            }));
        } catch (error) {
            console.log(error);
        }
    }

    const handleClickGridItem = (e) => {
        e.preventDefault();
        let row = e.target.parentElement.parentElement.parentElement;
        let id = row.children[0].innerText;

        history.push("/grape-of-the-week-details", { params: { id, type: "INFORM" } });
    }

    const handleAddGrape = () => {
        history.push("/grape-of-the-week-details", { params: { type: "ADD" } });
    }

    const handleClickDelete = async (e) => {
        try {
            e.preventDefault();

            confirmAlert({
                title: 'Confirm to Delete',
                message: 'Are you sure to delete this grape of the week?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: async () => {
                            let row = e.target.parentElement.parentElement.parentElement;
                            let id = row.children[0].innerText;

                            let response = await deleteGrapeOfTheWeek({ id });
                            if (!response.success) return console.log(response.data);

                            await getGrapes();
                        }
                    },
                    {
                        label: 'No'
                    }
                ]
            });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getGrapes();
    }, []);

    return (
        <>
            <div className="page-content">
                <Row>
                    <Col xs="10" />
                    <Col xs="2">
                        <Button onClick={handleAddGrape} color="danger">Grape Of The Week Ekle</Button>
                    </Col>
                </Row>
                <Container fluid={true}>
                    <React.Fragment>
                        <Grid
                            data={grapes}
                            columns={[
                                "#", "Start Date", "End Date", "Name",
                                {
                                    name: 'Picture',
                                    width: '120px',
                                    formatter: (cell) => _(
                                        <>
                                            {(cell)
                                                ? <img src={cell} alt="main-glass" style={{ width: "100px", height: "100px" }} />
                                                : <></>
                                            }
                                        </>
                                    )
                                },
                                {
                                    name: 'Actions',
                                    width: '120px',
                                    formatter: (cell) => _(
                                        <>
                                            <Button type='button' onClick={handleClickGridItem} className='btn btn-sm btn-light'> Details </Button>
                                            <Button type='button' onClick={handleClickDelete} className='btn btn-sm btn-danger'> Delete </Button>
                                        </>
                                    )
                                }
                            ]}
                            search={true}
                            sort={true}
                            pagination={{ enabled: true, limit: 10 }}
                        />
                    </React.Fragment>
                </Container>
            </div>
        </>
    );
}

export default GrapeOfTheWeekTable;